<template>
  <div>
    <section class="section has-background-white">
      <div class="container">
        <div class="columns">
          <div class="column is-8 is-offset-2">
            <h1 class="title is-text-wrap-balance">Reisegutscheine für traumhafte Urlaubserlebnisse in Italien</h1>
            <div class="content is-text-wrap-pretty">
              <p>Entdecken Sie mit unseren Urlaubsgutscheinen die schönsten Seiten Italiens. Von der sonnigen Adriaküste bis zu den majestätischen Bergen Südtirols. Ob Badeurlaub am Meer, Wandern in den Alpen, 
                erholsame Wellness-Tage oder Wintersport, gestalten Sie Ihren Aufenthalt ganz nach Ihren Wünschen.</p>
              <p class="has-text-weight-bold">Jetzt zum Vorteilspreis buchen und sparen!
              </p>
              <p>Mit unseren Gutscheinen sichern Sie sich exklusive Angebote in ausgewählten Hotels - flexibel und besonders günstig.</p>
              <p class="has-text-weight-bold">Italien genießen - clever & günstig mit Urlaubsgutscheinen!</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section section-offers has-background-white-ter">
      <div class="container">
        <div v-if="!hasOffers">
          <NoOffer />
        </div>

        <div v-if="hasOffers">
          <h2 class="title is-size-4 has-text-centered">{{ $t('product.offers-end-in') }}</h2>
          <CountdownTimer :endTime="campaignTimer" class="has-text-centered timer-lp mb-6" />

          <!-- bzw für normale suche haspromotion | Custom:suedtirol -->

          <div v-if="traveldeal.length == 1">
            <div v-for="o in traveldeal" :key="o.id">
              <Deal :product="o" class="deal--suedtirol" v-bind:has-countdown="false" />
            </div>
          </div>

          <div class="columns is-multiline is-variable is-5" v-if="traveldeal.length > 1">
            <div class="column is-half-tablet" v-for="o in traveldeal" :key="o.id">
              <DealSmall :product="o" v-bind:has-countdown="false" />
            </div>
          </div>

          <div class="columns is-multiline is-variable is-5">
            <div class="column is-half-tablet is-one-third-desktop is-flex" v-for="o in offers" :key="o.id">
              <OfferElement :product="o" class="offer--suedtirol" />
            </div>
          </div>

          <p class="has-text-centered has-text-weight-bold mt-5">Viele weitere Urlaubsgutscheine warten hier auf Sie!</p>
          <div class="has-text-centered mt-3">
            <b-button tag="router-link" to="/" type="is-dark">
              Zu allen Angeboten
            </b-button>
          </div>
        </div>
      </div>
    </section>

    <section class="section has-background-white is-hiden-mobile">
      <div class="container">
        <Advantages v-bind:size="'small'" class="mb-4" />
      </div>
    </section>
  </div>
</template>

<script>
import Advantages from '@/components/Advantages'
import CountdownTimer from '@/components/CountdownTimer'
import OfferElement from '@/components/OfferElement'
import OfferApi from '@/api/offer-api'
import Deal from '@/components/Deal'
import DealSmall from '@/components/DealSmall'
import promotion from '@/common/promotion'

const NoOffer = () => import(/* webpackPrefetch: true , webpackChunkName: "nooffer" */ '@/components/NoOffer')

export default {
  name: 'suedtirol',
  components: {
    Advantages,
    CountdownTimer,
    OfferElement,
    NoOffer,
    Deal,
    DealSmall,
  },
  data() {
    return {
      offers: [],
      traveldeal: [],
      promotionEndDate: '',
      hasOffers: false,
    }
  },
  computed: {
    campaignTimer: function() {
      //let endDate = new Date('2021-11-25') - new Date()
      let endDate = this.promotionEndDate - new Date()
      return endDate
    },
  },
  methods: {
    isTravelDeal(f) {
      return promotion.hasActivePromotion('TravelDeal', f)
    },
  },
  async mounted() {
    let offers = await OfferApi.getOffersWithCustomPromotion('bellaitalia')
    this.offers = offers.filter(item => !this.isTravelDeal(item))

    this.traveldeal = offers.filter(item => this.isTravelDeal(item))

    this.promotionEndDate = promotion.getEndDateForPromotionOnly('Custom:bellaitalia', this.$store.getters.promotions)

    this.hasOffers = this.offers.length > 0 || this.traveldeal.length > 0
  },
  metaInfo() {
    return {
      title: 'Bella Italia',
      meta: [{name: 'description', content: 'Reisegutscheine für traumhafte Urlaubserlebnisse in Italien'}],
    }
  },
}
</script>

<style lang="scss"></style>
